import GetAppIcon from '@mui/icons-material/GetApp';
import React from 'react';

import { CellIconButton } from './CellIconButton';

export const CellPdfButton = ({ links }: { links: { rel: string, href: string }[] }) => {
  const pdfLink = links.find(link => link.rel === 'pdf');
  if (!pdfLink) {
    return '';
  }
  return (
    <CellIconButton icon={<GetAppIcon fontSize='small' />} href={pdfLink.href} />
  );
};
